import { observer } from "mobx-react-lite"
import "./about.css"
import { Flex } from "antd";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";

const MobileApps = observer(() => {
    const { t } = useTranslation();

    return (
        <div style={{ marginBottom: "100px" }}>
            <h1><img src="/assets/about/apps_icon_title.svg" alt="" /> <span className="blue-text">{t("MOBILE")} </span> <span className="rubik">{t("APPS")}</span> </h1>
            <div className="row" >
                <Flex justify="center">
                    <div>
                        <div className="text-center">
                            <img src="/assets/about/apps_icon.svg" alt="" />
                        </div>
                        <h3 className="black-text">{t("Works anywhere")} <strong className="blue-text">{t("you")}</strong> {t("go")}</h3>
                        <div className="small-text">{t("Desktop or tablet, you’re always in sync.")}</div>
                        <Flex justify="space-between" align="stretch" style={{ marginTop: "20px" }}>
                            <Link to="https://play.google.com/store/apps/details?id=app.sunpoint.sktech" target="_blank">
                                <img src="/assets/about/downloadon_AS.svg" alt="" />
                                <div className="available">{t("Available now")}</div>
                            </Link>
                            <Link to="https://apps.apple.com/us/app/sktech/id6738701533" target="_blank">
                                <img src="/assets/about/getiton_GP.svg" alt="" />
                                <div className="available">{t("Available now")}</div>
                            </Link>
                        </Flex>
                        <div className="features-text">{t("All features work smoothly on mobile.")}</div>
                    </div>
                    <div className="features-image">
                        <img src={`/assets/about/tabs/${i18n.language}/app_showcase.svg`} alt="" />
                    </div>
                </Flex>
            </div>
        </div>
    )
})
export default MobileApps;